import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { CheckboxField } from '~admin/view/components/ui/form/fields/field-checkbox.component';
import { NumberField } from '~admin/view/components/ui/form/fields/field-number.component';
import { SelectField } from '~admin/view/components/ui/form/fields/field-select.component';
import { TaxType } from '~client/model/admin/tax-type';
import { Box } from '~common/components/box.component';
import { Column } from '~common/components/column.component';
import { optionEnumeratorMapper } from '~common/components/select.helper';

export interface EventFeeFormData {
  flatFee?: number;
  resaleFlatFee?: number;
  creditCardFeeRate?: number;
  sellerCreditCardFeeRate?: number;
  profitFeeRate?: number;
  taxType?: TaxType;
  includedInBase?: boolean;
}

export interface EventFeeDetailsFormData {
  fees?: EventFeeFormData;
}

export const EventFeeDetails: React.FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <Row>
        <RestrictBox>
          <NumberField
            name={'fees.flatFee'}
            label={t('createEvent.eventDetails.taxes.flat')}
            decimal
          />
        </RestrictBox>
        <RestrictBox>
          <NumberField
            name={'fees.resaleFlatFee'}
            label={t('createEvent.eventDetails.taxes.resale')}
            decimal
          />
        </RestrictBox>
      </Row>
      <Row>
        <RestrictBox>
          <NumberField
            name={'fees.creditCardFeeRate'}
            label={t('createEvent.eventDetails.taxes.credit')}
            endAdornment={'%'}
            decimal
          />
        </RestrictBox>
        <RestrictBox>
          <NumberField
            name={'fees.sellerCreditCardFeeRate'}
            label={t('createEvent.eventDetails.taxes.seller')}
            endAdornment={'%'}
            decimal
          />
        </RestrictBox>
        <RestrictBox>
          <NumberField
            name={'fees.profitFeeRate'}
            label={t('createEvent.eventDetails.taxes.profit')}
            endAdornment={'%'}
            decimal
          />
        </RestrictBox>
      </Row>
      <Row>
        <RestrictBox>
          <SelectField
            name={'fees.taxType'}
            label={t('createEvent.eventDetails.taxes.taxType.fieldLabel')}
            options={optionEnumeratorMapper(
              TaxType,
              t,
              'createEvent.eventDetails.taxes.taxType.enum',
            )}
          />
        </RestrictBox>
        <RestrictBox>
          <CheckboxField
            name={'fees.includedInBase'}
            label={t('createEvent.eventDetails.taxes.includedInBase')}
          />
        </RestrictBox>
      </Row>
    </Container>
  );
};

const Container = styled(Column)`
  flex: 1 1 auto;
  border: 2px solid ${(props): string => props.theme.colors.gray.v3};
  border-radius: 16px;
  padding: 16px;
`;

const Row = styled(Box)`
  margin-top: 12px;
  > div:not(:first-child) {
    margin-left: 50px;
  }
`;

const RestrictBox = styled(Box)`
  flex: 1 1 auto;
`;



// WEBPACK FOOTER //
// ./view/components/details/event-details/event-fee-details.component.tsx